import { MENUBAR_ID } from "widgets/NavBar/NavBar";
import { BREAKPOINTS } from "design_system/src/hooks/useResizeObserver";

const BANNER_CLONE_TIMEOUT_MS = 5000;

export const cloneHeaderToInvisibleNavbar = () => {
    // need to clone welcome banner to invisible to position main content properly
    // use MutationObserver to wait for React to finish rendering before cloning
    const cloneBannerWhenReady = () => {
        const welcomeBannerElement = $(".welcome-banner");
        if (welcomeBannerElement.length > 0 && welcomeBannerElement.children().length > 0) {
            welcomeBannerElement.clone().prependTo($("body > .invisible"));
            return true;
        }
        return false;
    };

    const headerElements = $(".welcome-banner");
    if (headerElements.length === 0) {
        return;
    }

    const headerElement = headerElements.get(0) as HTMLElement;

    const observer = new MutationObserver(() => {
        // check if requestIdleCallback is supported
        if (typeof requestIdleCallback !== "undefined") {
            requestIdleCallback(() => {
                if (cloneBannerWhenReady()) {
                    observer.disconnect();
                }
            });
        } else {
            setTimeout(() => {
                if (cloneBannerWhenReady()) {
                    observer.disconnect();
                }
            }, 0);
        }
    });

    observer.observe(headerElement, {
        childList: true,
        subtree: true,
        attributeFilter: ["style", "class"],
    });

    // in case it never loads
    setTimeout(() => {
        observer.disconnect();
    }, BANNER_CLONE_TIMEOUT_MS);
};

/**
 * Calculate the padding-top of the main content based on the Header height.
 * Header includes anything inside of the <header> tag.
 */
export const setMainPaddingTop = () => {
    const headerElement = document.getElementsByTagName("header")?.[0];
    const headerHeight = headerElement ? headerElement.clientHeight : 0;
    const isNarrowScreen = window.innerWidth < BREAKPOINTS.s768;
    const dropdownMenu = document.getElementById(MENUBAR_ID);
    const dropdownMenuHeight = dropdownMenu?.clientHeight || 0;

    if (isNarrowScreen && dropdownMenuHeight > 0) {
        return;
    }

    const mainContent = document.querySelector("main");
    mainContent?.style.setProperty("padding-top", `${headerHeight}px`);
};

/**
 * Attach listeners to the page and header elements for events where
 * the header size could possibly change.
 */
export const loadHeaderHeightObserver = () => {
    window.addEventListener("resize", setMainPaddingTop);
    window.addEventListener("load", setMainPaddingTop);

    const headerElement = document.querySelector("header");
    if (headerElement) {
        new MutationObserver(() => {
            // Wait until transitions from mutations have settled down
            requestIdleCallback(setMainPaddingTop);
        }).observe(headerElement as Element, {
            childList: true,
            subtree: true,
            attributeFilter: ["style", "class"],
        });
    }

    setMainPaddingTop();
};
